{
  "info": "정보",
  "negative": "오류",
  "positive": "성공"
}
